import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../../auth/hooks/useAuth";

export const BusinessAdminGuard: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { user, isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Show loading state
  if (loading) {
    return <div>Loading...</div>;
  }

  // Check authentication first
  if (!isAuthenticated || !user) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  // Check user role
  if (!user.is_cloud_user && !user.is_store_owner) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  // Check subscription status
  if (!user.is_subscribed) {
    return <Navigate to="/subscription" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
